/**
 * @file 快速开始 api
 * @author FengGuang(fengguang01@baidu.com)
 */
import request from 'superagent';
import baseRequest2 from '../baseApi2';

// 获取搜索结果
export const fetchGetSearchList = (): Promise<request.Response> => {
    const searchParams = new URLSearchParams(window.location.search.slice(1));

    if (!searchParams.get('searchType')) {
        searchParams.set('searchType', 'all');
    }
    if (!searchParams.get('version')) {
        searchParams.set('version', '2.4');
    }

    return baseRequest2(request.get('/searchResult').query(searchParams.toString()));
};
